import _ from "@/boot/lodash";
import i18n from "@/i18n";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`,
      slots: event => {
        const hasTicketId = _.has(event.object, "ticket_id");
        return _.union([
          {
            slot: "name",
            is: "strong",
            message: event.object?.user_name || event.object?.client_name
          },
          {
            slot: "ticket",
            is: hasTicketId ? "u-link" : "span",
            message: (i18n.t("_.ticket") as string).toLowerCase(),
            props: hasTicketId
              ? {
                  tag: "router-link",
                  to: {
                    name: "adminSupportTicket",
                    params: { ticketId: event?.object?.ticket_id }
                  }
                }
              : {}
          }
        ]);
      }
    })
  }
});

export default {
  ...createEventMap(HookCodes.USER_POSTED_TICKET_MESSAGE),
  ...createEventMap(HookCodes.USER_POSTED_TICKET_MESSAGE, {
    slots: event => [
      {
        slot: "name",
        is: "strong",
        message: event?.object?.client_name
      }
    ]
  }),
  ...createEventMap(HookCodes.USER_POSTED_PRIVATE_TICKET_MESSAGE, {
    icon: {
      name: "exclamation-circle",
      type: "is-warning"
    }
  }),
  ...createEventMap(HookCodes.USER_ASSIGNED_TO_TICKET),
  ...createEventMap(HookCodes.CLIENT_POSTED_TICKET_MESSAGE),
  ...createEventMap(HookCodes.CLIENT_UPDATED_TICKET_MESSAGE),
  ...createEventMap(HookCodes.USER_UPDATED_PRIVATE_TICKET_MESSAGE),
  ...createEventMap(HookCodes.USER_UPDATED_TICKET_MESSAGE),
  ...createEventMap(HookCodes.LEAD_POSTED_TICKET_MESSAGE, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.LEAD_POSTED_PRIVATE_TICKET_MESSAGE_TO_LEAD, {
    icon: icon.success
  })
};
